<template>
  <el-drawer
    ref="drawer"
    v-bind="$attrs"
    :with-header="false"
    :size="size"
    class="rt-xpc-drawer"
    v-on="$listeners"
  >
    <div
      v-if="withHeader"
      id="rt-drawer__title"
      class="rt-drawer__header"
    >
      <div
        v-if="headerType === 'menu'"
        class="header-container"
      >
        <rt-button
          icon-name="rt-base-menu_spread"
          color-type="info"
          icon-size="24"
          type="plain"
          text
          @click="closeDrawer"
        />
        <slot name="title">
          <span class="__title-menu">{{ title }}</span>
        </slot>
      </div>
      <div
        v-else
        class="header-container"
      >
        <slot name="title">
          <span class="__title-close">{{ title }}</span>
        </slot>
        <rt-button
          icon-name="rt-base-close-x"
          color-type="info"
          icon-size="24"
          type="plain"
          text
          @click="closeDrawer"
        />
      </div>
    </div>
    <slot></slot>
    <div
      v-if="$slots.footer"
      class="rt-drawer__footer"
    >
      <slot name="footer"></slot>
    </div>
  </el-drawer>
</template>
<script>
import RtButton from '../button/rtButton.vue';
import ElDrawer from 'vue-xpc/src/element-ui/packages/drawer';
export default {
  name: 'RtDrawer',
  components: { RtButton, ElDrawer },
  // components: { RtButton },
  props: {
    withHeader: {
      type: Boolean,
      default: true
    },
    headerType: {
      type: String,
      default: 'menu'
    },
    title: String,
    size: {
      type: String,
      default: '400px'
    }
  },
  methods: {
    closeDrawer () {
      const _closeDrawer = () => {
        this.$emit('close');
        this.$refs.drawer.closeDrawer();
      };

      if (this.$listeners && this.$listeners['before-close']) {
        new Promise(resolve => {
          const done = () => resolve(true);
          const stop = () => resolve(false);
          this.$emit('before-close', done, stop);
        }).then(needClose => needClose && _closeDrawer());
      } else {
        _closeDrawer();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDrawer.vue?f9b60fd6